import { render, staticRenderFns } from "./Semnatura.vue?vue&type=template&id=d6c61fbe&scoped=true"
import script from "./Semnatura.vue?vue&type=script&lang=js"
export * from "./Semnatura.vue?vue&type=script&lang=js"
import style0 from "./Semnatura.vue?vue&type=style&index=0&id=d6c61fbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c61fbe",
  null
  
)

export default component.exports